module.exports = {"341623100":"城关镇","341623101":"阚疃镇","341623102":"张村镇","341623103":"江集镇","341623104":"旧城镇","341623105":"西潘楼镇","341623106":"孙集镇","341623107":"汝集镇","341623108":"巩店镇","341623109":"王人镇","341623110":"王市镇","341623111":"永兴镇","341623112":"马店孜镇","341623113":"大李集镇","341623114":"胡集镇","341623115":"展沟镇","341623116":"程家集镇","341623117":"中疃镇","341623118":"望疃镇","341623119":"城北镇","341623203":"纪王场乡","341623204":"孙庙乡","341623205":"新张集乡","341623400":"柴湖良种繁殖场","341623401":"利辛县工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341623.json
// module id = 1053
// module chunks = 0